export default __webpack_public_path__ + "static/accents-icons-light-5eec96f625502bbdb206cc50f4550f26.png";